/**
 * SILENCIO TEMPORAL DE LA SINCRONIZACIÓN EN TIEMPO REAL
 * ------------------------------------------------------------------
 * `landing_pages` y `forms` están en la publicación de Realtime, así que cada
 * vez que el propio usuario guarda una landing recibe de vuelta su propio
 * evento y se dispara `refresh()`, que recarga TODO el espacio de trabajo
 * (leads, notas, actividades, envíos, respuestas, equipo, biblioteca…). Eso
 * convertía un guardado de dos escrituras en decenas de consultas y bloqueaba
 * la interfaz durante varios segundos.
 *
 * Las escrituras propias silencian el canal durante una ventana corta: los
 * cambios ya están en la caché local (`cacheLanding`), así que no hay nada que
 * volver a descargar. Los cambios de OTROS usuarios siguen refrescando normal.
 *
 * Módulo minúsculo y sin dependencias a propósito: lo importan tanto los
 * servicios (que se cargan también en las páginas públicas) como `realtime.ts`
 * (que solo se carga en la zona privada), sin arrastrar uno al otro.
 */

let mutedUntil = 0

/** Silencia el refresco automático durante `ms` milisegundos. */
export function muteRealtime(ms = 3000): void {
  mutedUntil = Math.max(mutedUntil, Date.now() + ms)
}

/** Indica si el refresco automático está silenciado en este momento. */
export function isRealtimeMuted(): boolean {
  return Date.now() < mutedUntil
}
